//----------- IMPORTAÇÕES -----------//
// Lead Page com importação de CSV avançada com preview e mapeamento
import { useEffect, useContext } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Loading } from "../../shared/components";
import { LoadingContext } from "../../shared/context/LoadingContext"
import { Main } from "./components"
import { IntegracoesContext } from "./context/IntegracoesContext";
import { loadIntegrationsService, loadLeadsService } from "./services";


//----------- EXPORTAÇÃO DA PÁGINA LEADS ---------//
export default function Leads() {



  //----------- CRIAÇÃO DE HOOKS -----------//
  const { integrations, setIntegrations } = useContext(IntegracoesContext);
  const { leads, setLeads } = useContext(IntegracoesContext);
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const { itemsPerPage, setItemsPerPage } = useContext(IntegracoesContext);
  const { currentPage, setCurrentPage } = useContext(IntegracoesContext);



  //------------ USE EFFECT DE INICIALIZAÇÃO ---------//
  useEffect(() => {
    setIsLoading(true)
    handleLoadIntegrations();
  }, []);



  //-------- FUNÇÃO ASSÍNCRONA CARREGAR TAGS ----------//
  // Nesta função, é requisitado à API as TAGS armazenadas.
  // AS TAGS retornadas pela API são armazenadas no Estado "tags" .
  async function handleLoadIntegrations() {
    const response = await loadIntegrationsService();
    if (response) {
      setIntegrations(response.data);
      setIsLoading(false);
      let filtred_integrations = [];
      let i = itemsPerPage;

      for (i; i > 0; i--) {
        if (response.data[(currentPage * itemsPerPage) - i]) {
          filtred_integrations.push(response.data[(currentPage * itemsPerPage) - i].id);
        }
      }
      await handleLoadLeads(filtred_integrations);
    }
  };



  //-------- FUNÇÃO ASSÍNCRONA CARREGAR LEADS ----------//
  // Nesta função, é requisitado à API as LEADS armazenadas.
  async function handleLoadLeads(integrations) {
    const response = await loadLeadsService(integrations);
    if (response) {
      const todasLeads = [];
      for (let cliente of response.data.clientes) {
        for (let transacao of cliente.transacoes) {
          todasLeads.push(...transacao.leads);
        }
      }
      setLeads(todasLeads);
    }
  };



  //---------- RETORNO CONDICIONAL DA PÁGINA LEADS ----------//
  return (
    <>
      {isLoading || integrations === null ? <Loading /> : <Main />}
    </>
  )
}